import React from 'react';
import cx from 'classnames';

import {
  Button,
  TextField,
} from 'spindl-shared-components';

import styles from './SendEmailMenu.module.scss';
import usePresenter from './SendEmailMenu.presenter';
import getProps from './SendEmailMenu.props';
import { SendEmailMenuCombinedProps } from './types';

const SendEmailMenu: React.FC<SendEmailMenuCombinedProps> = (props) => {
  const {
    type,
    className,
    classes,
    textField,
    button,
  } = usePresenter(props);

  const variantName = `${type}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles.sendEmailMenu;

  // MANUAL OVERRIDE
  return (
    <div className={cx(currentStyle, className)}>
        <TextField
          className={cx(styles.textField, classes?.textField)}
          {...internalProps.textField}
          {...textField}/>
        <Button
          className={cx(styles.button, classes?.button)}
          {...internalProps.button}
          {...button}/>
    </div>
  );
};

export default SendEmailMenu;

